<template>
  <!--01企业简介开始-->
  <div @contextmenu="tabRight"
       @touchstart="touchstarts()"
       @touchmove="touchmoves()"
       @touchend="touchends()">
    <!--内容结构开始-->
    <div class="video-introduction">
      <!-- 区块标题 -->
      <tit :blockData="blockData"
           :src='rightSrc'
           @clear="clearSrc"
           :subtitle="blockData.subtitle"
           @refesh="refeshData"></tit>
      <div v-if="!rightSrc"
           ref="centerEle">
        <qyjjContent :blockData='blockData' />
      </div>

    </div>
    <!--内容结构结束-->
  </div>
  <!--01企业简介结束-->
</template>
<script>
import tit from "./control/tit.vue"
import qyjjContent from "./qyjjContent.vue"
export default {
  name: "qyjj",
  components: {
    tit: tit,
    qyjjContent
  },
  props: {
    blockData: {
      type: Object
    }
  },
  data () {
    return {
      timeOutEvent: 0,
      rightSrc: '',
      height: '',
      heights: '',
      leftTabInd: 0,
      topTabInd: 0,
      contendId: '',
      floorDetailShow: '',
      introData: {
        pictures: null,
        others: null
      },
      nodeId: '',
      blockId: '',
      flowId: ''
    }
  },
  mounted () {
    // var pDataArr = this.blockData.dataArr;
    // if(pDataArr.length){
    //     this.getProduct(pDataArr);
    // }
    this.nodeId = this.blockData.nodeId;
    this.flowId = this.blockData;
    this.getBlockByFlowId(this.blockData.id);
    this.$http
      .get("/zciid-deliverable/showPlatformStyle/flow/api/getShowFlowPosition.json", {
        // appId:this.blockData.appId,
        appId: this.getQuery('appId'),
        flowId: this.blockData.id,
        flowOrDetail: 'detail',
        domainNameType: document.location.pathname.split('/')[1]
      }).then(res => {
        this.floorDetailShow = res.data ? res.data : 'down'
      })
    var _this = this;
    //监听中间块高度
    var elementResizeDetectorMaker = require("element-resize-detector")
    var erd = elementResizeDetectorMaker();
    //监听中心展示高度
    erd.listenTo(this.$refs.centerEle, function (element) {
      _this.heights = element.clientHeight;
    })
  },
  computed: {
    tagData () {
      return this.$store.state.tagData;
    }
  },
  methods: {
    touchstarts () {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.tabRight();
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmoves: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchends: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    //关闭中心iframe
    clearSrc () {
      this.rightSrc = '';
    },
    tabRight () {
      this.$store.commit('setFlowType', this.blockData.floorType);
      window.$floorflowId = '';
      window.$nodeId = '';
      if (this.nodeId) {
        window.$nodeId = this.nodeId;
      }
      if (this.flowId) {
        window.$floorflowId = this.flowId;
      }
      if (this.contentId) {
        if (!window.$rightLeft) {
          window.$rightLeft = {}
        }
        window.$rightLeft.center = {
          //     contentId:this.contentId,
          //     contentShowRowsSort:'0'
        }
      }
    },
    getProduct (pDataArr) {
      var pictures = [];
      var others = [];
      if (pDataArr && pDataArr.length > 0) {
        this.contentId = pDataArr[0].contentId;
        let intro = pDataArr[0].standardJson;
        if (intro) {
          intro.forEach((ele) => {
            if (ele.standardData) {
              if ((ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0) || ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.jpeg') > 0) {
                pictures.push(ele.standardData);
              } else {
                others.push(ele);
              }
            }
          });
        }
      }
      if (pictures.length == 0) {
        pictures = []
      }
      if (others.length == 0) {
        others = [{ standardData: '我是标题' }, { standardData: '我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据我是数据。' }]
      }
      this.introData.pictures = pictures;
      this.introData.others = others;
    },
    getBlockByFlowId (id) {
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getBlockDataListByFlowPid.json", {
          // appId:this.blockData.appId,
          appId: this.getQuery('appId'),
          flowId: id
        })
        .then(res => {
          if (res.state == 1) {
            var Blockitem = res.data[0];
            return Blockitem;
          } else {
            this.getProduct([]);
          }

        }).then(Blockitem => {
          if (Blockitem) {
            this.getTagsByBlockId(Blockitem);
          }

        });
    },
    getTagsByBlockId (item) {
      this.blockId = item.id;
      window.$blockId = item.id;
      this.nodeId = item.nodeId;
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getContentDataByBlockNodeId.json", {
          // appId:this.blockData.appId,
          appId: this.getQuery('appId'),
          sceneId: item.sceneId,
          blockId: item.id,
          nodeId: item.nodeId,
          sceneGroupId: item.sceneGroupId,
        }).then(res => {
          if (res.state == 1) {
            this.getProduct(res.data);
          }
        })
    },
    handleDetail () {
      var blockId = this.blockData.blockId;
      var contentId = this.contentId;

      sessionStorage.setItem('floorDetailShow', this.floorDetailShow);
      sessionStorage.setItem('originName', JSON.stringify({ blockId: blockId, contentId: contentId }));
      var appId = this.$appId;
      // const { href } = this.$router.resolve({ path: "flowDetail", query: { appId: appId, blockId: blockId, contentId: contentId } })
      // // this.open(href);
      // window.location.assign(href);
      this.routerJump('push','flowDetail',{ appId: appId, blockId: blockId, contentId: contentId },'');

    },
    isVideo (t) {
      var ty = false;
      if (t) {
        if (t.indexOf('.flv') > 0) {
          ty = true
        }
        if (t.indexOf('.mp4') > 0) {
          ty = true
        }
      }
      return ty;
    },
    refeshData () {
      this.rightSrc = '';
    }
  }
}
</script>
<style>
/*m01_视频简介 开始*/
.video-introduction .video-info-box {
  display: flex;
}
.video-introduction .video-info-box .video-box,
.video-introduction .video-info-box .video-intro {
  height: 375px;
  width: 50%;
  flex: 1;
  padding: 20px;
}
.video-introduction .video-intro .tit {
  height: 48px;
  font-size: 20px;
  line-height: 48px;
  color: #333;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
/* .video-introduction .video-intro .text{height:auto; line-height: 30px;font-size: 14px;color: #333;padding-top: 6px;overflow:hidden; text-overflow:ellipsis;display:-webkit-box; -webkit-box-orient:vertical;-webkit-line-clamp:8;text-align: justify;word-wrap: break-word;} */
.video-introduction .video-intro .more-btn {
  height: 30px;
  width: 100px;
  background: #37a7ff;
  border-radius: 3px;
  position: absolute;
  bottom: 0px;
  right: 0px;
  text-align: center;
  color: #fff;
  line-height: 30px;
  cursor: pointer;
}
.video-introduction .video-intro .more-btn:hover {
  background: #2f8eed;
}
.video-introduction .video-intro .more-btn a {
  display: block;
  width: 100%;
  height: 100%;
  color: #ffffff;
}
/* 超小屏幕（手机，小于 768px） */
/* @media screen and (min-width:426px) and (max-width: 768px) { 
    .video-introduction .video-intro .tit{font-size:16px;}
    .video-introduction .video-intro .text{font-size:12px;}
    .video-introduction .video-info-box {display:block;}
    .video-introduction .video-info-box .video-box,.video-introduction .video-info-box .video-intro { width: calc(100% - 40px);padding:0 20px;height:auto;}
    .video-introduction .video-info-box .video-box video{height:170px;}
} */
/* 小屏幕（平板，大于等于 768px） */
/* @media (min-width: 768px) {

 } */
</style>


// WEBPACK FOOTER //
// src/components/floorBlock/qyjj.vue